import { useMemo } from "react";

import type { BranchNodeType } from "@citrine/resources/branch";
import { BRANCH_NODE_TYPES } from "@citrine/resources/branch";

import * as sx from "./project-navigation.sx";
import type { ProjectStepProps } from "./project-step";
import { ProjectStep } from "./project-step";
import { ProjectToolbar } from "./project-toolbar";

function ProjectNavigationView({
  steps,
}: {
  steps: Record<BranchNodeType, Omit<ProjectStepProps, "nodeType">>;
}) {
  return steps ? (
    <sx.Steps data-testid="project-steps">
      {BRANCH_NODE_TYPES.map((nodeType) => (
        <ProjectStep key={nodeType} {...steps[nodeType]} nodeType={nodeType} />
      ))}
    </sx.Steps>
  ) : null;
}

export function ProjectNavigation({
  projectId,
  workspaceId,
  executionId,
}: {
  projectId: string;
  workspaceId?: string;
  executionId?: string;
}) {
  const steps = useMemo(() => {
    return {
      data: {
        titleId: "resources.data.tables" as const,
        to: `/projects/${projectId}/data`,
      },
      predictor: {
        titleId: "resources.predictors" as const,
        to: `/projects/${projectId}/predictors`,
      },
      design: {
        titleId: "resources.search-spaces" as const,
        to: `/projects/${projectId}/search-spaces`,
      },
      candidate: {
        titleId: "resources.candidates" as const,
        to:
          workspaceId && executionId
            ? `/projects/${projectId}/workspaces/${workspaceId}/executions/${executionId}`
            : "",
      },
    };
  }, [projectId, workspaceId, executionId]);

  return (
    <ProjectToolbar projectId={projectId}>
      <ProjectNavigationView steps={steps} />
    </ProjectToolbar>
  );
}
